module.exports = __webpack_public_path__ + "static/media/wallpaper-4.733a4c5d.jpg";